import { render } from "./ModalNuovaPrenotazione.vue?vue&type=template&id=473b9f98&scoped=true"
import script from "./ModalNuovaPrenotazione.vue?vue&type=script&lang=js"
export * from "./ModalNuovaPrenotazione.vue?vue&type=script&lang=js"

import "./ModalNuovaPrenotazione.vue?vue&type=style&index=0&id=473b9f98&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473b9f98"]])

export default __exports__